import * as Yup from "yup";
const quotaField = Yup.mixed()
  .test(
    "is-valid-quota",
    "Must be a positive number followed by a valid unit (e.g., '50 MB', '100 GB') or 'Unlimited'",
    (value) => {
      if (typeof value === 'string') {
        const trimmed = value.trim();
        
        if (trimmed.toLowerCase() === "unlimited") return true;
        
        const regex = /^[0-9]+(\.[0-9]+)?\s?(MB|GB|KB|TB|PB)$/i;
        
        if (regex.test(trimmed)) return true;
        
        const num = Number(trimmed);
        if (Number.isInteger(num) && num > 0) return true;
      }
      
      if (typeof value === 'number') {
        if (Number.isInteger(value) && value > 0) return true;
      }
      return false;
    }
  )
  .required("This field is required");


const planValidationSchema = Yup.object({
  planCategory: Yup.string().required("Plan Category is required"),
  planClassification: Yup.string().required("Plan Classification is required"),
  planDuration: Yup.string().required("Plan Duration is required"),
  validity: Yup.number() .typeError("Only digits allowed")
  .integer("Must be an integer")
  .positive("Must be positive")
  .max(99, "Maximum 2 digits allowed")
  .required("Validity is required"),
  planName: Yup.string().required("Plan Name is required"),
  planCode: Yup.string().required("Plan Code is required"),
 
  speedType: Yup.string().required("Speed Type is required"),
  rentExclTax: Yup.number(),
  rentInclTax: Yup.number(),
  rentlTax: Yup.number()
    .positive("Rental Tax must be positive")
    .required("Rental Tax is required"),
  primaryQuota: quotaField,
  secondaryQuota: Yup.string(),
  popPlan: Yup.string().required("POP Plan selection is required"),
  popBestSeller: Yup.string().required("POP Best Seller is required"),
  status: Yup.string().required("Status is required"),
 
});

export default planValidationSchema;
